import { useTranslations } from "next-intl";
import { cn } from "@repo/ui/lib/utils";

export default function NoResults({
  text,
  className,
}: {
  text?: string;
  className?: string;
}) {
  const t = useTranslations("Components.NoResults");

  return (
    <div
      className={cn(
        "w-full h-20 flex justify-center items-center text-3xl font-semibold",
        className,
      )}
    >
      <span className={"text-inherit"}>{text || t("no-results")}</span>
    </div>
  );
}
